import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {Form, Select, message, DatePicker, Row, openNotice, Col, Input, Button} from 'antd';
const FormItem = Form.Item;
const Option = Select.Option;
import {nameValidator, checkNumber} from '../../utils/regexp';
import {DmsTab, TableView, FilterBox} from 'Components';
import {fetchList, addSurvey} from '../../service/survey';
import index from 'antd/lib/button';

class SurveyAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['新建问卷调查'],
            question: [
                {
                    'sortOrder': 1,
                    'type': '',
                    'questionName': '',
                    'showOption': 1,
                    'answer': [
                        {
                            'sortOrder': 'A',
                            'optionName': ''
                        },
                        {
                            'sortOrder': 'B',
                            'optionName': ''
                        },
                        {
                            'sortOrder': 'C',
                            'optionName': ''
                        },
                        {
                            'sortOrder': 'D',
                            'optionName': ''
                        },
                        {
                            'sortOrder': 'E',
                            'optionName': ''
                        }
                    ]
                }
            ],
            problemTypeData: [
                {
                    'id': '0',
                    'text': '单选题'
                },
                {
                    'id': '1',
                    'text': '多选题'
                },
                {
                    'id': '2',
                    'text': '填空题'
                }
            ]
        };
    }

    componentWillMount() {
    }

    componentDidMount(){
    }

    //页面跳转
    goView = (url) => {
        hashHistory.push(url);
    }

    goBack = () => {
        hashHistory.goBack();
    }
    submit = () => {
        const {validateFields, getFieldsValue} = this.props.form;

		validateFields((errors) => {//表单校验
			if (errors) {
				return
			}//表单校验有误，则不执行下面的代码
			const data = {
				...getFieldsValue() //获取用户输入
            };
            data.expireDate = Date.parse(data.expireDate);
            data.question = this.state.question;
            // console.log(data);
            addSurvey(data).then((result)=>{
                if (result && result.code == 200){
                    // openNotice('success', '添加成功', result.message);
                    // openNotice('success', (result && result.message) ? result.message : '');
                    hashHistory.goBack();
                } else {
                    // openNotice('error', '添加失败', result.message);
                    // openNotice('error', (result && result.message) ? result.message : '');
                }
            })
        })

        // addSurvey(this.state.question).then((result)=>{
        //     console.log(result);
        // })
    }
    dateOnChange = () => {

    }

    dateOnOk = () => {

    }

    addProblemFn = () => {
        this.state.question.push({
            'sortOrder': this.state.question.length + 1,
            'type': 0,
            'questionName': '',
            'showOption': 1,
            'answer': [
                {
                    'sortOrder': 'A',
                    'optionName': ''
                },
                {
                    'sortOrder': 'B',
                    'optionName': ''
                },
                {
                    'sortOrder': 'C',
                    'optionName': ''
                },
                {
                    'sortOrder': 'D',
                    'optionName': ''
                },
                {
                    'sortOrder': 'E',
                    'optionName': ''
                }
            ]
        });
        this.setState(this.state.question);
    }

    deleteProblemFn = (index) => {
        this.state.question.splice(index, 1);
        this.state.question.map(function (qst, key) {
            qst.sortOrder = key + 1;
        });
        this.setState(this.state.question);
    }

    problemTypeFn = (index, value) => {
        var self = this;
        this.state.question[index].type=value
        this.setState({question: this.state.question}, () => {
            if (value == 2) {
                self.state.question[index].showOption = 0;
                var optionData = self.state.question[index].answer;
                for (var i = 0;i < optionData.length; i++) {
                    self.refs['option' + index + optionData[i].sortOrder].value = '';
                }
                self.state.question[index].answer = optionData;
            } else {
                self.state.question[index].showOption = 1;
            }
            self.setState({question: self.state.question});
        });
    }
    answerChange = (key, index, e) => {
        this.state.question[key].answer[index].optionName = e.target.value;
        this.setState({question: this.state.question});
    }
    titalChange = (key, e) => {
        this.state.question[key].questionName = e.target.value;
        this.setState({question: this.state.question});
    }
    render() {
        var self = this;
        const {opts} = this.state;
        const formItemLayout = {
            labelCol: { span: 2 },
            wrapperCol: { span: 12, offset: 1 }
        };
        const {getFieldDecorator} = this.props.form;

        var problemTypeOptions = self.state.problemTypeData.map(function (qst, key) {
            return <Option key={key} value={qst.id}>{qst.text}</Option>
        }.bind(this));

        var problemHtmlRender = self.state.question.map(function (qst, key) {
            var optionData = qst.answer || [];
            var optionHtmlRender = optionData.map(function (q, k) {
                return (
                  <Row key={k}>
                    <Col>
                      <label>答题选项{q.sortOrder}</label>
                      <Input type="text" maxLength="100" ref={'option' + key + q.sortOrder} name={'option' + key + q.sortOrder} onChange={self.answerChange.bind(self,key,k)}/>
                    </Col>
                  </Row>
                )
            });
            return (
              <div className="problem_list" key={key}>
                  <Row>
                    <Col>
                        <label>题目{qst.sortOrder}</label>
                        <Button type="danger" style={{marginLeft: 60, display: self.state.question.length > 1 ? 'inline-block' : 'none'}} onClick={self.deleteProblemFn.bind(self, key)}>删除</Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>题型</label>
                      <Select ref={'problemTypeIds' + key} name={'problemTypeIds' + key} value={self.state.question[key].type} onChange={self.problemTypeFn.bind(self, key)}>
                            {problemTypeOptions}
                      </Select>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>标题</label>
                      <Input onChange={self.titalChange.bind(self,key)} />
                  </Col>
                  </Row>
                  <div style={{display: qst.showOption == 1 ? 'block':'none'}}>
                      {optionHtmlRender}
                  </div>
              </div>
            )
        });

        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                    </DmsTab>
                </div>

                <div className="dms-table-box" style={{backgroundColor: "#fff"}}>
                    <Form layout="horizontal">
                        <FormItem label="评测主题" {...formItemLayout}>
                            {getFieldDecorator('title', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入评测主题'
                                    }
                                ]
                            })(<Input placeholder="请输入评测主题"/>)}
                        </FormItem>

                        <FormItem label="评测描述" {...formItemLayout}>
                            {getFieldDecorator('description', {
                                rules: [
                                    {
                                        required: true
                                    }
                                ],
                            })(<Input.TextArea placeholder="请输入评测描述"/>)}
                        </FormItem>

                        {/*<FormItem label="可获积分" {...formItemLayout}>
                            {getFieldDecorator('score', {
                                rules: [
                                    {
                                        message: '请输入可获积分',
                                        validator: checkNumber
                                    }
                                ],
                            })(<Input placeholder="请输入可获积分"/>)}
                        </FormItem>*/}

                        <FormItem label="过期日期" {...formItemLayout}>
                            {getFieldDecorator('expireDate', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入过期日期'
                                    }
                                ]
                            })(<DatePicker
                                showTime={false}
                                format="YYYY-MM-DD"
                                placeholder="请选择过期日期"
                                onChange={this.dateOnChange}
                                onOk={this.dateOnOk}
                            />)}
                        </FormItem>

                        <FormItem>
                            <Button style={{background: '#2dc3e8', color: '#fff'}} onClick={this.addProblemFn}>添加题目</Button>
                        </FormItem>
                        <FormItem>
                            {problemHtmlRender}
                        </FormItem>
                        <FormItem>
                            <Button style={{background: '#2dc3e8', color: '#fff'}} onClick={this.addProblemFn}>添加题目</Button>
                        </FormItem>
                        <FormItem wrapperCol={{ span: 24, offset: 12 }} style={{ marginTop: 24 }}>
                            <Button htmlType="submit" onClick={this.goBack}>取消</Button>
                            <Button type="primary" htmlType="submit" onClick={this.submit} style={{ marginLeft: 20 }}>确定</Button>
                        </FormItem>

                    </Form>
                </div>
            </div>
        )
    }
};
export default Form.create()(SurveyAdd);




// WEBPACK FOOTER //
// ./src/routes/survey/add.js